var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-section',{attrs:{"title":"趋势图"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',[_c('div',{style:(`width: 900px; height: ${750 * _vm.zoom}px ;zoom:${
          1 / _vm.zoom
        };transform:scale(${_vm.zoom});transform-origin:0 0`),attrs:{"id":_vm.title}})])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }